import poster from "../assets/images/summer-country-tour-2026.jpg";

export const campaign = {
  slug: "summer-country-tour-2026",
  title: "Summer Country Tour",
  year: "2026",
  organiser: "Watuwave",
  poweredBy: "Mutzig",
  poster,
  ticketTypes: ["REGULAR", "VIP", "VVIP"],
  artists: ["Bruce Melodie", "The Ben Tiger B", "Kitoko", "Bwiza"],
  stops: [
    {
      id: "musanze",
      city: "Musanze",
      slug: "summer-country-tour-2026",
      date: "13 June 2026",
      shortDate: "13 Jun",
      isoDate: "2026-06-13",
    },
    {
      id: "nyagatare",
      city: "Nyagatare",
      slug: "summer-country-tour-nyagatare",
      date: "20 June 2026",
      shortDate: "20 Jun",
      isoDate: "2026-06-20",
    },
    {
      id: "bugesera",
      city: "Bugesera",
      slug: "summer-country-tour-bugesera",
      date: "27 June 2026",
      shortDate: "27 Jun",
      isoDate: "2026-06-27",
    },
    {
      id: "rubavu",
      city: "Rubavu",
      slug: "summer-country-tour-rubavu",
      date: "4 July 2026",
      shortDate: "4 Jul",
      isoDate: "2026-07-04",
    },
  ],
  fallbackTickets: [
    { type: "REGULAR", price: 2000 },
    { type: "VIP", price: 5000 },
    { type: "VVIP", price: 10000 },
  ],
};

export function isCampaignEvent(title?: string, slug?: string) {
  const normalizedTitle = title?.toLowerCase() ?? "";
  const normalizedSlug = slug?.toLowerCase() ?? "";

  return (
    campaign.stops.some((stop) => stop.slug === normalizedSlug) ||
    normalizedTitle.includes("summer country tour")
  );
}

export function getCampaignStopBySlug(slug?: string) {
  return campaign.stops.find((stop) => stop.slug === slug);
}
